import { createSelector } from '@ngrx/store';
import { getMenuState, MenuState } from '../menu.reducer';
import { MenuBaseState } from './menu-base.reducer';
import {MenuDateUtil} from '@emm/core/util/menu-date.util';

const getState = createSelector(getMenuState, (state: MenuState) => state?.base);
const getEffectiveDate = createSelector(getState, (state: MenuBaseState) => state.effectiveDate);
const getIsFutureDate = createSelector(getEffectiveDate, (date) => MenuDateUtil.isFutureDate(date));
const getIsToday = createSelector(getEffectiveDate, (date) => MenuDateUtil.isToday(date));
const getIsInitialized = createSelector(getState, (state) => state.initialized);

export const MenuBaseSelectors = {
    getEffectiveDate,
    getIsFutureDate,
    getIsInitialized,
    getIsToday
};
